import { useEffect, useState } from "react";

const FRASI = [
  "Apparecchio i tavoli",
  "Accendo i fornelli",
  "Preparo le comande",
  "Sveglio il monitor di cucina",
  "Conto le bottiglie",
];

/**
 * Schermata d'avvio: il primo caricamento può prendere qualche secondo, tanto vale renderlo
 * un momento di marchio invece di una scritta grigia.
 */
export const Avvio = ({ nome = "Reprehendo", nota = "" }) => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % FRASI.length), 1900);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-6 bg-slate-950 px-8 text-center"
         data-testid="avvio-splash">
      <div className="relative">
        <span className="absolute -inset-6 animate-ping rounded-full border border-amber-500/30" />
        <span className="absolute -inset-3 rounded-full border border-amber-500/20" />
        <span className="relative flex h-24 w-24 items-center justify-center rounded-2xl bg-amber-500 font-head text-4xl font-bold text-slate-950 shadow-[0_0_60px_-10px_rgba(245,158,11,.7)]">
          RH
        </span>
      </div>

      <div>
        <p className="font-head text-2xl font-bold tracking-tight text-white" data-testid="avvio-nome">{nome}</p>
        <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.3em] text-amber-500">Reprehendo</p>
      </div>

      <div className="w-full max-w-[240px]">
        <div className="h-[3px] overflow-hidden rounded-full bg-slate-800">
          <div className="h-full w-1/3 animate-[scorri_1.6s_ease-in-out_infinite] rounded-full bg-amber-500" />
        </div>
        <p className="mt-3 h-5 text-xs text-slate-400" data-testid="avvio-frase">
          {nota || `${FRASI[i]}…`}
        </p>
      </div>

      <style>{`@keyframes scorri {
        0% { transform: translateX(-100%); }
        50% { transform: translateX(200%); }
        100% { transform: translateX(-100%); }
      }`}</style>
    </div>
  );
};
